import React from 'react';
import { Table, Button } from 'react-bootstrap';
import moment from 'moment';

export const ExpenseTable = ({ expenses, onDelete, onEdit }) => {
    return (
        <Table responsive hover className="table-striped">
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Category</th>
                    <th>Amount</th>
                    <th>Date</th>
                    <th>Type</th>
                    <th>Description</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                {expenses.map((expense) => (
                    <tr key={expense.id}>
                        <td>{expense.name}</td>
                        <td>
                            <span className="badge bg-primary">
                                {expense.category}
                            </span>
                        </td>
                        <td className="text-danger">
                            ${parseFloat(expense.amount).toFixed(2)}
                        </td>
                        <td>{moment(expense.date).format('MMM DD, YYYY')}</td>
                        <td>
                            <span className={`badge bg-${expense.fixed ? 'success' : 'warning'}`}>
                                {expense.fixed ? 'Fixed' : 'Variable'}
                            </span>
                        </td>
                        <td>{expense.description}</td>
                        <td>
                            <div className="d-flex gap-2">
                                <Button 
                                    variant="outline-primary" 
                                    size="sm"
                                    className="btn-icon"
                                    onClick={() => onEdit(expense)}
                                >
                                    <i className="ri-pencil-line"></i>
                                </Button>
                                <Button 
                                    variant="outline-danger" 
                                    size="sm"
                                    className="btn-icon"
                                    onClick={() => onDelete(expense.id)}
                                >
                                    <i className="ri-delete-bin-line"></i>
                                </Button>
                            </div>
                        </td>
                    </tr>
                ))}
                {expenses.length === 0 && (
                    <tr>
                        <td colSpan="7" className="text-center py-4">
                            No expenses found
                        </td>
                    </tr>
                )}
            </tbody>
        </Table>
    );
}; 